import { createFileRoute } from '@tanstack/react-router';

import { InsightsPage } from '@/components/insights/insights-page';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/insights/')({
  loader: () => loadNamespaces('insights'),
  staticData: {
    title: 'route.insights.title',
    messageContext: { context_type: 'workspace' },
  },
  component: InsightsPage,
});
